export const formatINR = (value) =>
  value == null ? 'Price on request' : `₹${Number(value).toLocaleString('en-IN')}`;

export const calculateLineTotal = (price, quantity) => {
  const numericPrice = Number(price);
  const numericQuantity = Number(quantity);
  if (price == null || !Number.isFinite(numericPrice) || !Number.isFinite(numericQuantity)) return null;
  return numericPrice * Math.max(0, numericQuantity);
};

export const calculateCartSummary = (items) =>
  items.reduce((summary, { product, qty }) => {
    const lineTotal = calculateLineTotal(product?.price, qty);
    if (lineTotal === null) {
      summary.quoteQuantity += Number(qty) || 0;
      summary.quoteLines += 1;
    } else {
      summary.pricedTotal += lineTotal;
    }
    return summary;
  }, { pricedTotal: 0, quoteQuantity: 0, quoteLines: 0 });

export const formatCartValue = ({ pricedTotal, quoteQuantity }) => {
  if (quoteQuantity > 0 && pricedTotal > 0) {
    return `${formatINR(pricedTotal)} + ${quoteQuantity} quote ${quoteQuantity === 1 ? 'item' : 'items'}`;
  }
  if (quoteQuantity > 0) return 'Price on request';
  return `${formatINR(pricedTotal)} · estimated`;
};

export const normalizeIndianPhone = (value) => {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
  if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
  return /^[6-9]\d{9}$/.test(digits) ? digits : '';
};

export const isoDate = (date = new Date()) => {
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const earliestOrderDate = (products, date = new Date()) => {
  const noticeDays = products.reduce(
    (days, product) => Math.max(days, Number(product?.leadTimeDays) || 0),
    0
  );
  const earliest = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  earliest.setDate(earliest.getDate() + noticeDays);
  return isoDate(earliest);
};

export const prettyDate = (iso) => {
  if (!iso) return 'Flexible';
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return 'Flexible';
  return date.toLocaleDateString('en-IN', {
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
  });
};
